import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { MomentPipe } from '../pipes/moment/moment.pipe';
import { BtnGroupHorizontalComponent } from '../shared/btn-group-horizontal/btn-group-horizontal.component';
import { FileUploadComponent } from './fileUpload/file-upload.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import {
  DxDataGridModule,
  DxPivotGridModule,
  DxSelectBoxModule,
} from 'devextreme-angular';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
//import { AccordionModule } from 'ngx-accordion';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    DragulaModule,
    NgxDatatableModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxPivotGridModule,
    NgMultiSelectDropDownModule,
    //AccordionModule,
  ],

  providers: [MomentPipe, DragulaService, DecimalPipe],
})
export class ComponentsModule {}
